import { render, staticRenderFns } from "./Training-views.vue?vue&type=template&id=674c7257"
import script from "./Training-views.vue?vue&type=script&lang=js"
export * from "./Training-views.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports